import { assign } from "lodash";

/* Unschön: doppelt zu den Angaben in App.css */
const fonts = "Verdana,Arial,Helvetica,sans-serif";
const fontSize = 10;

export const almigBlue = "#067bba";
export const almigOrange = "#ed8f00";

/* keine Ahnung ... */
const colors = [
	"#252525",
	"#525252",
	"#737373",
	"#969696",
	"#bdbdbd",
	"#d9d9d9",
	"#f0f0f0"
];
  
const baseProps = {
};

const baseLabelStyles = {
	fontFamily: fonts,
	fontSize,
	letterSpacing: "normal",
	padding: 10,
	fill: almigBlue,
	stroke: "transparent"
};
  
export default {
	axis: assign({
		style: {
			axis: {
				stroke: almigBlue
			},
			grid: {
				fill: "none",
				stroke: "none"
			},
			ticks: {
				stroke: almigBlue,
				size: 5
			},
			tickLabels: assign({}, baseLabelStyles, {
				padding: 5
			}),
			axisLabel: assign({}, baseLabelStyles, {
				angle: 90,
				padding: 15
			})
		}
	}, baseProps),
	chart: {
		width: 450,
		height: 300,
		padding: {
			top: 5,
			left: 25,
			bottom: 30	/* wegen Datum+Uhrzeit */
		}
	},
	tooltip: {
		style: assign({}, baseLabelStyles, {
			padding: 0,
			pointerEvents: "none"
		}),
		flyoutStyle: {
			stroke: almigOrange,
			strokeWidth: 1,
			fill: "#f7f7f7",
			pointerEvents: "none"
		},
		cornerRadius: 5,
		pointerLength: 5
	},
	bar: assign({
		style: {
			data: {
				fill: almigOrange,
				padding: 8,
				strokeWidth: 0
			},
			labels: baseLabelStyles
		}
	}, baseProps),
	legend: {
		colorScale: colors,
		gutter: 10,
		orientation: "horizontal",
		titleOrientation: "top",
		style: {
			data: {
				type: "square"
			},
			labels: baseLabelStyles,
			title: assign({}, baseLabelStyles, { padding: 5 })
		}
	}
};
